<template>
<v-tooltip top v-if="staff">
  <v-chip
    v-if="staff"
    small
    slot="activator"
    outline
    class="nx-primary--lighten-4 nx-text--level-1">
    <v-avatar size="16px" color="grey lighten-1">
      <img v-if="staff.avatarUrl"
           :src="staff.avatarUrl"
           :alt="`${staff.nick}`">
      <span v-else>{{ staff.name[0] }}</span>
    </v-avatar>
    {{ `${staff.nick}` }}
  </v-chip>
  <span v-html="label || $t('message.metadata.creationStaffId')"></span>
</v-tooltip>
</template>

<script>
export default {
  props: {
    label: String,
    staff: Object,
  },
};
</script>
